"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAuctionCreatedMockData = void 0;
const email_theme_tokens_1 = require("../../helpers/email-theme-tokens");
const email_templates_1 = require("../../internationalization/locales/email-templates");
const subject_templates_1 = require("./subject-templates");
const buildAuctionCreatedMockData = ({ orgName = "Bright Futures Foundation", formTitle = "Spring Charity Auction 2026", firstName = "John", showBankAccountNote = true, formUrl = "https://www.zeffy.com/en-US/auction/spring-charity-auction-2026", editUrl = "https://www.zeffy.com/dashboard/forms", bankAccountUrl = "https://www.zeffy.com/dashboard/settings/bank-account", locale = "en", subject = (0, subject_templates_1.buildTicketingCreatedSubject)(locale, formTitle), } = {}) => {
    return {
        labels: (0, email_templates_1.getEmailLabels)(locale),
        theme: (0, email_theme_tokens_1.getOrgFacingEmailTheme)(),
        currentYear: new Date().getFullYear(),
        lang: locale,
        subject,
        isPreview: false,
        orgName,
        formTitle,
        firstName,
        showBankAccountNote,
        formUrl,
        editUrl,
        bankAccountUrl,
    };
};
exports.buildAuctionCreatedMockData = buildAuctionCreatedMockData;
